
import { OperationResultEnum, OperationStatus } from "../AjaxCallerTsImplementation/AjaxOperationEnums";

export interface SuccessCallbackFunction<T> {
    (result: any): void;
}

export interface ValidationFailureCallbackFunction {
    (result: any): void;
}

export interface SystemErrorCallbackFunction {
    (result: any): void;
}

export interface FailureCallbackFunction {
    (result: any): void;
}

export interface NotFoundCallbackFunction {
    (result: any): void;
}

export interface FinishedCallbackFunction {
    (): void;
}

export interface ICallbackResult extends ICallbackResultWithType<any> {
}

export interface ICallbackResultWithType<T> {
    Success(callback: SuccessCallbackFunction<T>): ICallbackResultWithType<T>;
    ValidationFailure(callback: ValidationFailureCallbackFunction): ICallbackResultWithType<T>;
    SystemError(callback: SystemErrorCallbackFunction): ICallbackResultWithType<T>;
    Failure(callback: FailureCallbackFunction): ICallbackResultWithType<T>;
    NotFound(callback: FailureCallbackFunction): ICallbackResultWithType<T>;
    Finished(callback: FinishedCallbackFunction): ICallbackResultWithType<T>;
}


export interface ICallBackObject {
    NotifyOperationResult(operationResult);
}

export class CallBackObject implements ICallBackObject, ICallbackResult {
    constructor(private clientLoggingEnabled: boolean) { }

    NotifyOperationResult = function (operationResult: any) {
        var log = this.clientLoggingEnabled;
        switch (operationResult.Result) {
            case OperationResultEnum.SUCCESS:
                if (log)
                    console.log(operationResult.Data);
                this.NotifySuccess(operationResult.Data);
                break;

            case OperationResultEnum.VALIDATION_FAILED:
                if (log)
                    console.error(operationResult.ValidationErrors);
                this.NotifyValidationFailure(operationResult.ValidationErrors);
                break;

            case OperationResultEnum.OPERATION_FAILED:
                if (log)
                    console.error(operationResult.LocalizedErrorMessage);
                this.NotifyFailure(operationResult.LocalizedErrorMessage);
                break;

            case OperationResultEnum.SYSTEM_ERROR:
                if (log)
                    console.error(operationResult.ErrorMessage);
                this.NotifySystemError(operationResult.ErrorMessage);
                break;
        };
        this.notifyFinished();
    }

    NotifyStatusResult = function (operationResult: any) {
        var log = this.clientLoggingEnabled;
        switch (operationResult.Result) {
            case OperationStatus.NOTFOUND:
                if (log)
                    this.notifySuccess(operationResult.Data);
                break;
        };
        this.notifyFinished();
    }


    NotifySuccess = function (result) {
        if (this.successCallback)
            this.successCallback(result);
    };

    NotifyValidationFailure = function (validationResult) {
        if (this.validationFailureCallback)
            this.validationFailureCallback(validationResult);
    };

    NotifySystemError = function (errorMessage) {
        if (this.systemErrorCallback)
            this.systemErrorCallback(errorMessage);
    };

    NotifyFailure = function (localizedErrorMessage) {
        if (this.failureCallback)
            this.failureCallback(localizedErrorMessage);
    };

    NotifyFinished = function () {
        if (this.finishedCallback)
            this.finishedCallback();
    };

    NotifyNotFound = function () {
        if (this.notFoundCallBack)
            this.notFoundCallBack();
    };

    //ICallbackResult -section

    Success = function (callbackFunction) {
        if (callbackFunction !== undefined)
            this.successCallback = callbackFunction;
        return this;
    };

    ValidationFailure = function (callbackFunction) {
        if (callbackFunction !== undefined)
            this.validationFailureCallback = callbackFunction;
        return this;
    };

    SystemError = function (callbackFunction) {
        if (callbackFunction !== undefined)
            this.systemErrorCallback = callbackFunction;
        return this;
    };

    Failure = function (callbackFunction) {
        if (callbackFunction !== undefined)
            this.failureCallback = callbackFunction;
        return this;
    };

    NotFound = function (callbackFunction) {
        if (callbackFunction !== undefined)
            this.notFoundCallBack = callbackFunction;
        return this;
    };

    Finished = function (callbackFunction) {
        if (callbackFunction !== undefined)
            this.finishedCallback = callbackFunction;
        return this;
    };
}